export const iconFontAwesomeMapsSnowplow = (
	<i className="fa-solid fa-snowplow"></i>
);
